import type { AppDefinition } from '../../types/apps';

export const PageAppV2Definition: AppDefinition = {
  appId: 'page-v2',
  name: 'Page',
  version: '2.0.0',
  description: 'Notion-style pages with tasks, buttons, embeds, and rich content.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Article',
    phosphorWeight: 'duotone',
  },
  component: 'PageApp_v2',
  entityTypes: ['Page'],
  requiresProps: false,
  requiresEntity: true,
};
